<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Pay period - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">

            <div class="form-group">
                <label for="period">Pay period</label>
                <input type="text" 
                class="form-control" 
                id="first" 
                placeholder="Pay period"
                v-model="period">
                <div class="invalid-feedback" v-if="errors.period">{{ errors.period[0] }}</div>
            </div>
        <hr>
        <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-sm">Save</button>
        </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as payPeriodService from '../../services/payPeriod.service';
    export default {
        name:"ModalPayPeriodNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                period:''
            }
        },
        methods:{
            ...mapActions(['fetchPayPeriodAll']),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                let formData = new FormData();
                formData.append('period',this.period);
            try{
                const response = await payPeriodService.add(formData);
                this.hideModal();
                this.fetchPayPeriodAll();

                messageService.fnSweetAlertSuccessToast('Pay period - new', 'added successfully');

                this.period = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Pay period - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Pay period - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>